<template>
  <div class="page-content"  id="brandPartyAdd">
  <div>
    <el-breadcrumb separator="/">
			<el-breadcrumb-item><span style="cursor: pointer;" @click="gotoSetting(1)">系统设置</span></el-breadcrumb-item>
			<el-breadcrumb-item><span style="cursor: pointer;" @click="gotoSetting(2)">品牌方活动价格设置</span></el-breadcrumb-item>
			<el-breadcrumb-item>新增</el-breadcrumb-item>
    </el-breadcrumb>
    <section class="seaerch-wrapper">
      <el-form label-width="130px">
        <el-form-item label="申报平台：" :required="true">
          <el-select v-model="platform" placeholder="请选择" size="small" style="width: 425px;">
            <el-option
              v-for="item in platformList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="活动时间：" :required="true">
					<el-date-picker
						size="small"
						style="width: 425px;"
			      v-model="timeDate"
						value-format="yyyy-MM-dd"
			      type="daterange"
			      range-separator="至"
			      start-placeholder="开始日期"
			      end-placeholder="结束日期"
            :picker-options="pickerOptions">
			    </el-date-picker>
        </el-form-item>

				<el-form-item label="活动店铺：" :required="true">
          <el-radio :label="1" v-model="noticeType">指定店铺</el-radio>
          <el-radio :label="2" v-model="noticeType">附件上传店铺</el-radio>
        </el-form-item>
				<el-form-item label="店铺" v-if="noticeType == 1" :required="true">
          <div style="display: flex;">
            <div class="addFont" @click="changeShop()" style="margin-top: 5px;">
              <i class="el-icon-plus"></i>
              选择店铺
            </div>
            <div style="color: #ccc;margin-left: 8px;">
              已选 {{valueData.length}} 个店铺
            </div>
          </div>
          <div style="width: 715px;height: 130px;background: #f4f4f5;margin-top: 20px;overflow: auto;">
            <div class="shopNameClass" v-for="item in valueData">
              {{item.shopName}}
            </div>
          </div>
        </el-form-item>
				<el-form-item  v-if="noticeType == 2" style="position: relative;">
					<span style="content: '*';color: #F56C6C;margin-right: 4px;position: absolute;left: -78px;">
						*
					</span>
					<uploadBean @uploadBeanData="uploadBeanData" :uploadChange="uploadChange"></uploadBean>
				</el-form-item>

        <el-form-item label="活动产品：" :required="true">
          <div class="addFont" @click="newAdd">
            <i class="el-icon-plus"></i>
            新增活动产品
          </div>
        </el-form-item>
      </el-form>
      <el-table
        @selection-change="handleSelectionChange"
        :data="productsData"
        ref="multipleTable"
        style="padding-left: 47px;padding-bottom: 10px;"
        height="460"
        >
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column label="产品信息" prop="name">
        </el-table-column>
        <el-table-column width="210" label="操作">
          <template slot-scope="scope">
            <div class="g-margin-left" style="color: #108cee;cursor: pointer;">
              <i class="el-icon-delete"></i>
              <span class="g-inline-block" @click="delSure(scope.$index)">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <childMonitoring ref="childMonitoring" @selectedfirm="onComfirm" @fatherBlur="inputBlur"/>
      <div style="margin-left: 51px;margin-top: 40px;">
				<!-- <el-button size="small" class="g-confirm-btn" @click="save" type="primary" :loading="saveLoading">确 认</el-button> -->
        <el-button size="small" class="g-confirm-btn" @click="save" type="primary">确 认</el-button>
  			<el-button size="small" class="g-cancel-btn" @click="$router.push(`/newProductPandect`)" type="TheCustom">取 消</el-button>
      </div>
    </section>
  </div>
	<el-dialog
		title='选择店铺'
		:visible.sync="setShopShow"
		:close-on-click-modal="false"
		width="960px"
		id="activityDeclarationdialog">
		<el-transfer
			filterable
			:filter-method="filterMethod"
			filter-placeholder="请输入店铺名称"
			v-model="valueIndex"
			:button-texts="['到左边', '到右边']"
			:titles="['不通知店铺', '通知店铺']"
			:data="transferData"
			@change="leftChange"
			>
		</el-transfer>
		<span slot="footer">
			<el-button size="small" type="TheCustom" @click="setShopShow = false">关 闭</el-button>
		</span>
	</el-dialog>
</div>

</template>

<script>
  import axios from "axios";
  import childMonitoring from "../../components/childMonitoring/childMonitoring.vue";
	import uploadBean from "@/views/NotificationPublic/uploadBean";
  import { mapActions } from 'vuex';
  export default {
    data() {
      return {
				uploadChange: '3',
				timeDate: [],
				contentArr: [],
				valueIndex: [],
				valueData: [],
				transferData: [],
				filterMethod(query, item) {
          return item.label.indexOf(query) > -1;
        },
				setShopShow: false,
				noticeType: 1,
				value1: '',
				platformList: [
					{ value: 'TB', label: '淘宝' },
					{ value: 'TM', label: '天猫' },
					{ value: 'JD', label: '京东' },
					{ value: 'SN', label: '苏宁' },
					{ value: '1688', label: '1688' },
					{ value: 'DD', label: '当当' },
					{ value: 'PDD', label: '拼多多' },
				],
        status: 0,
        saveLoading: false,
        multipleSelection:[],
        openid: [],
        planname: '',
        plathour: [],
        platform: '',
        productsData: [],
        faData: [],
        chiLdNum: 0,
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < (Date.now()-1000*60*60*24);
          }
        },
      }
    },
    methods: {
			// 组件获取表格导入的数据
	    uploadBeanData(val) {
				if (!this.platform) {
					this.$message({
						message: '请先选择申报平台',
						type: "warning"
					});
					return;
				}
	      let that = this
	      that.valueData = []
	      // 去重
	      let obj = {};
	      let peon = val.reduce((cur,next) => {
	          obj[next.shopName] ? "" : obj[next.shopName] = true && cur.push(next);
	          return cur;
	      },[]) //设置cur默认类型为数组，并且初始值为空的数组
	      let bigSmall
	      if (peon.length < val.length) {
	        bigSmall = val.length - peon.length
	        this.$message({
	          message: '共计导入' + val.length + '条，自动去重' + bigSmall+ '条，剩余' + peon.length + '条',
	          type: 'success'
	        });
	      }
				let newData = []
				for (let a in peon) {
					newData.push({
						shopName: peon[a].shopName,
						platformCode: this.platform
					})
				}
	      axios({
	         method: 'post',
	         url: 'hcm/campaignSettingprice/validationshopname ',
	         headers: {
	           'Content-type': 'application/json;charset=UTF-8'
	         },
	         data: newData,
	         timeout: 60 * 1000 * 50
	      }).then(function (response) {
	        if (response.data.status == "10000") {
						if (response.data && response.data.data && response.data.data.length != 0) {
							for (let a in response.data.data) {
								that.valueData.push({
									shopName: response.data.data[a].shopName,
									id: response.data.data[a].id
								})
							}
						}
	          if (that.valueData.length == 0) {
	            that.$message({
	              message: '未匹配到店铺信息',
	              type: 'warning'
	            });
	            return
	          }
	          that.$message({
	            message: '验证成功',
	            type: 'success'
	          });
	        } else {
	          that.$message.error(response.data.message)
	        }
	      }).catch(err => {
	        this.$message.error('接口异常');
	      });
	    },
			// 选择店铺
			changeShop() {
				if (!this.platform) {
					this.$message({
						message: '请先选择申报平台',
						type: "warning"
					});
					return;
				}
				this.getPageByBmcs()
			},
			// 跳转到上一级
			gotoSetting(e) {
				if (e == 1) {
					this.$router.push('/systemSetupList/systemSetup');
				} else {
					this.$router.push('/brandPartySetting');
				}
			},
			getPageByBmcs(){
        let params = {
          pageSize: 5000,
          pageNo: 1,
        }
				if (this.platform) {
					params.platform_code = this.platform
				}
        fetch({url: "hcm/hcmShop/getPageByBmc", method: "get", params}).then((res)=>{
          this.contentArr = []
          this.valueIndex = []
					this.valueData = []
          if (res.data.content && res.data.content.length != 0) {
						if (this.platform == 'TB' || this.platform == 'TM') {
							for (let a in res.data.content) {
	              this.contentArr.push({
	                shopName: res.data.content[a].platformname + ' ' +res.data.content[a].wangwang + " (旺旺)",
	                id: res.data.content[a].id
	              })
	            }
						} else {
							for (let a in res.data.content) {
	              this.contentArr.push({
	                shopName: res.data.content[a].platformname + ' ' +res.data.content[a].shopName,
	                id: res.data.content[a].id
	              })
	            }
						}

            this.generateData()
          }
        })
      },
			generateData() {
        this.transferData = [];
        this.contentArr.forEach((city, index) => {
          this.transferData.push({
            label: city.shopName,
            key: index,
          });
        });
				this.setShopShow = true
        return this.transferData;
      },
			leftChange(left,right) {
        let idsArr = []
        if (left instanceof Array) {
          this.valueIndex = left
        } else {
          this.valueIndex = right
        }
        if (this.valueIndex && this.valueIndex.length != 0) {
          for (let b in this.valueIndex) {
            idsArr.push(this.contentArr[this.valueIndex[b]].id)
          }
        }
        this.valueData = []
        for (let a in this.contentArr) {
          for (let e in idsArr) {
            if (this.contentArr[a].id == idsArr[e]) {
              this.valueData.push(this.contentArr[a])
            }
          }
        }
      },

      // 子组件搜索
      inputBlur() {
        console.log('调用')
        this.newAdd()
      },
      // 新增监控产品
      newAdd() {
        let params = {
          pageNum: 1,
          pageSize: 10000,
        }
        fetch({
          url: "hcm/ProductClassify/seletProductClassify",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            let typeNum = 2
            this.$refs.childMonitoring.open(typeNum,res.data.data.list,this.productsData)
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      // 子传父
      onComfirm(data) {
        // 新增监控产品表格数据
        console.log('新增监控产品表格数据')
        console.log(data)
        this.productsData = data
        this.chiLdNum = 0
        this.chiLdNum = this.totalNum + this.productsData.length
      },
      delSure(index) {
        if (index == '批量删除') {
          if (this.multipleSelection.length === 0) {
            this.$message({
              message: '请选择产品信息',
              type: "error"
            });
            return;
          }
          for (let a in this.multipleSelection) {
            for (let b in this.productsData) {
              if (this.multipleSelection[a] === this.productsData[b]) {
                this.productsData.splice(b,1)
              }
            }
          }
        } else {
          this.productsData.splice(index,1)
        }
        this.chiLdNum = 0
        this.chiLdNum = this.totalNum + this.productsData.length
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      save() {
				console.log(this.timeDate)
        if (!this.platform) {
          this.$message({
            message: '请选择申报平台',
            type: 'warning'
          });
          return
        }
        if (this.timeDate.length == 0) {
          this.$message({
            message: '请选择活动时间',
            type: 'warning'
          });
          return
        }
        if (this.productsData.length == 0) {
          this.$message({
            message: '请添加活动产品',
            type: 'warning'
          });
          return
        }
        this.saveLoading = true
				let allData = []
				console.log(this.productsData)
        for (let b in this.productsData) {
          allData.push({
            id: this.productsData[b].productid,
						productClassifyName: this.productsData[b].name,
            productfield: this.productsData[b].productfield,
          })
        }
        let params = {
          platform: this.platform,
					productlist: allData,
					starttime: this.timeDate[0] + ' 00:00:00',
					endtime: this.timeDate[1] + ' 23:59:59',
					shoplist: this.valueData,
        }
        fetch({
          method: 'POST',
  				url: 'hcm/campaignSettingprice/savaSettingprice ',
  				data: JSON.stringify(params),
  				headers: {
  					'Content-Type': 'application/json'
  				}
        }).then(res => {
          if(res.status == '10000'){
            this.saveLoading = false
            this.$message({
              message: '成功',
              type: 'success'
            });
            // 新增的话数据清空
            if (!this.$route.query.id) {
              this.planname = ''
              this.platform = ''
              this.timeDate = []
              this.productsData = []
              this.openid= []
            }
            this.$router.push(`/brandPartySetting`)
          } else {
            this.$message.error(res.message);
          }
        })
      },
    },
    components: {
      childMonitoring,uploadBean
    }
  }
</script>
<style lang="scss">
  #brandPartyAdd{
		.el-transfer {
	    font-size: 14px;
	    height: 500px !important;
	  }
	  .el-transfer-panel {
	    width: 324px !important;
	    height: 500px !important;
	  }
	  .el-transfer-panel__list.is-filterable {
	    height: 396px !important;
	  }
    .el-table__empty-text {
      padding-top: 100px;
      background: url("../../assets/img/other/nodata.svg") no-repeat;
      background-position: center 66px;
    }
    .el-table th {
      background-color: #f2f6fe !important;
      color: #4a4b4c;
    }

    #dialog {
      .el-button--primary {
        color: #FFF;
        background-color: #bda571;
        border-color: #bda571;
      }
      .el-button--primary:hover {
        color: #FFF;
        background-color: #c0ae8a;
        border-color: #c0ae8a;
      }
    }
    .el-button--TheCustom {
      color: #666;
      border-color: #D9D9D9;
      background-color: #fff;
    }
    .el-button--TheCustom:hover  {
      color: #666;
      border-color: #ded2b8;
      background-color: #faf9f5;
    }
    .addFont {
      color: #108cee;
      font-weight: bold;
      text-align: center;
      border: 1px dashed #e8ebec;
      height: 30px;
      width: 425px;
      line-height: 30px;
      cursor: pointer;
    }
    .addFont:hover {
      border: 1px dashed #108cee;
    }
		.shopNameClass {
	    border: 1px solid #e8ebec;
	    text-align: center;
	    font-size: 12px;
	    float: left;
	    background: white;
	    margin: 10px 0 10px 10px;
	    padding: 0 10px 0 10px;
	    cursor: pointer;
	  }
  }
</style>
